import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  const menu = [
    {
      icon: 'config',
      name: i18n.t('agenda.sociedad'),
      path: 'masters/society',
      use_parent_params: true,
      params_required: ['id', 'selfInvoice'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/society/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('sedes.header'),
          path: 'masters/society/locations',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('companies.companies_link'),
          path: 'masters/society/linkedcompanies',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('agenda.sellers'),
          path: 'masters/society/usersproviders',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1' || params.selfInvoice === false,
          invisible: params.selfInvoice === false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'masters/society/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
  if (params.issuingCreation) {
    menu[0].sc = menu[0].sc.slice(0, 1)
  }
  return menu
}
